<div class="bingo-bt-lobby-container-main">
    <div class="bingo-bt-notification-toster-container">
        <div class="bingo-bt-notification-toster-body">
            <span class="mes">{{ notificationOffMsg }}{{ notificationOnMsg }}</span>
            <i class="theme-ex" (click)="close()"></i>
        </div>
    </div>
</div>
